// ignore-string-externalization

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ThemeProvider } from 'styled-components';
import { loadMe, selectMe } from '../shared/store/me';
import ScrollToTop from '../shared/components/ScrollToTop';
import PageHead from '../shared/components/PageHead';
import { MastheadFooter } from '../../features/Layout/MastheadFooter/';
import { LayoutState } from '../../features/Layout';
import { darkTheme } from '../../features/Theme';
import { Track } from '../../features/Tracking';
import Layout from './Layout';
import { MastheadHeader } from '../../features/Layout/MastheadHeader';
import { LanguageSelectionDialogWrapper } from '../../../features/src/i18n/components/LanguageSelection/LanguageSelectionDialogWrapper';

type Props = {
  loadMe: () => void;
  location: {
    pathname: string;
    search: string;
  };
  me?: {
    isEmployee?: boolean;
    hasAccess?: boolean;
    username?: string;
    features?: $TSFixMe;
    partnerIds?: {
      google?: string;
    };
  };
  children?: React.ReactNode;
  defaultMenuState?: {
    help?: boolean;
    resources?: boolean;
    side?: boolean;
  };
  history?: {
    push?: () => void;
  };
};

class Root extends Component<Props> {
  componentDidMount() {
    this.props.loadMe();
  }

  render() {
    const isPlain =
      /\.plain$/.test(this.props.location.pathname) ||
      /plain/.test(this.props.location.search);

    const NavComponent = () => {
      return (
        <LayoutState>
          <ThemeProvider theme={darkTheme}>
            <MastheadHeader />
          </ThemeProvider>
        </LayoutState>
      );
      // legacy nav: <Navigation me={this.props.me} />
    };

    return (
      <>
        <PageHead />
        <ScrollToTop>
          <Track>
            <Layout
              navigation={!isPlain && <NavComponent />}
              content={this.props.children}
              footer={
                !isPlain && (
                  <ThemeProvider theme={darkTheme}>
                    <MastheadFooter />
                  </ThemeProvider>
                )
              }
            />
            <LanguageSelectionDialogWrapper />
          </Track>
        </ScrollToTop>
      </>
    );
  }
}

const selector = createStructuredSelector({ me: selectMe });

const actions = { loadMe };

export default connect(selector, actions)(Root as $TSFixMe);
